<template>
<div >
  <div class="form-group">
    <label for="brand"><strong>MARCHIO</strong></label>
      <input @change="$emit('update',brand)" list="brandList" autocomplete="off" :required="props.required"  ref="brand"  class="form-control bold"  id="brands" name="brands" v-model="brand">
        <datalist id="brandList"> 
          <option v-if="props.all" :key="-1">TUTTI I BRAND</option>                       
          <option v-for="(item,index) in items" :key="index">{{item.brand}} </option>        
        </datalist>
  </div>  
</div>

</template>
<script>
import api             from "@/api";
import { mapGetters }  from 'vuex';
export default {
  props : ['props'] , 
  components: {},
  data() {
    return {
      brand                  : '',
      items                  : [],
      spinner                : false
     
    };
  },
  computed :{
    ...mapGetters(['company']),
    
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  mounted: function() {
  
  },
  created: function() {
      
        this.getData()
      
  },
  methods: 
  {
    async getData()
    {
            
      var sp   = {'sp'         : 'spCompanyBrandList'}      
      var data = {'companyId'  : this.company.Id}
      var json  = Object.assign(data, sp)
      
      

      await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
              this.brand = this.props.Id
              
              


            }
           else if(res.status==500)
           {
                console.log(res.data)
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });
    
 



     
    },
  
    
    
  
}

}
</script>
<style scoped>

</style>